var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57902 2.00518L14.9297 13.0052C14.9882 13.1065 15.019 13.2215 15.019 13.3385C15.019 13.4555 14.9882 13.5705 14.9297 13.6718C14.8712 13.7732 14.787 13.8573 14.6857 13.9159C14.5843 13.9744 14.4694 14.0052 14.3524 14.0052H1.65102C1.534 14.0052 1.41904 13.9744 1.3177 13.9159C1.21635 13.8573 1.1322 13.7732 1.07369 13.6718C1.01518 13.5705 0.984374 13.4555 0.984375 13.3385C0.984376 13.2215 1.01518 13.1065 1.07369 13.0052L7.42436 2.00518C7.48287 1.90384 7.56703 1.81969 7.66837 1.76118C7.76972 1.70268 7.88467 1.67188 8.00169 1.67188C8.11871 1.67188 8.23367 1.70268 8.33501 1.76118C8.43635 1.81969 8.52051 1.90384 8.57902 2.00518ZM7.33502 10.6718V12.0052H8.66836V10.6718H7.33502ZM7.33502 6.00518V9.33851H8.66836V6.00518H7.33502Z",
    fill: "#FF4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.c85c8f707c838058e49799ade9fcb91b.svg";
export { ForwardRef as ReactComponent };